/**
 * @generated SignedSource<<6df2566b192fadb423e6ef30ab998e90>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateEmailInput = {
  clientMutationId?: string | null | undefined;
  newEmail: string;
  password: string;
};
export type UpdateEmailMutation$variables = {
  input: UpdateEmailInput;
};
export type UpdateEmailMutation$data = {
  readonly updateEmail: {
    readonly errors: any | null | undefined;
    readonly success: boolean | null | undefined;
    readonly user: {
      readonly email: string;
      readonly id: string;
      readonly username: string;
    } | null | undefined;
  } | null | undefined;
};
export type UpdateEmailMutation = {
  response: UpdateEmailMutation$data;
  variables: UpdateEmailMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateEmailPayload",
    "kind": "LinkedField",
    "name": "updateEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DjangoUserNode",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c269a2a81e2903321987ee450e4b2944",
    "id": null,
    "metadata": {},
    "name": "UpdateEmailMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateEmailMutation(\n  $input: UpdateEmailInput!\n) {\n  updateEmail(input: $input) {\n    success\n    errors\n    user {\n      id\n      email\n      username\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dc81deca569cab88d95c11b457695e02";

export default node;
